import React, { useEffect } from "react";
import { useRecommendationStore } from "./stores/recommendationStore";
import { useDocumentGeneratorStore } from "./stores/documentGeneratorStore";
import RecommendationTable from "./components/RecommendationTable/RecommendationTable";
import RecommendationHeader from "./components/RecommendationHeader/RecommendationHeader";
import {
  Loading,
  PaginationControls,
  PageHistory,
  PermissionWrapper,
} from "components";
import { recommendationHistoryConfig } from "./utils/recommendationHistoryConfig";

// Головний компонент сторінки рекомендацій
const RecommendationPage = () => {
  // Отримуємо дані та дії зі стору рекомендацій
  const filters = useRecommendationStore((state) => state.filters);
  const totalCount = useRecommendationStore((state) => state.totalCount);
  const isLoading = useRecommendationStore((state) => state.isLoading);
  const setPage = useRecommendationStore((state) => state.setPage);
  const init = useRecommendationStore((state) => state.init);

  // Отримуємо функцію скидання стану зі стору генерації документів
  const resetDocumentState = useDocumentGeneratorStore((state) => state.resetState);

  useEffect(() => {
    init();
  }, [init]);

  useEffect(() => {
    resetDocumentState();
  }, [resetDocumentState]);

  return (
    <section id="recommendationpage">
      <PermissionWrapper requiredPermission="activity_log:view">
        <PageHistory
          subjects={["recommendation_price", "recommendation_comment"]}
          config={recommendationHistoryConfig}
          contextFilters={{ warehouse_id: filters.warehouse_id }}
        />
      </PermissionWrapper>
      <div className="page-container">
        <RecommendationHeader />
        {isLoading ? (
          <Loading />
        ) : (
          <>
            <RecommendationTable />
            <PaginationControls
              page={filters.page}
              totalPages={Math.ceil(totalCount / filters.page_size) || 1}
              onPageChange={(page) => setPage(page)}
            />
          </>
        )}
      </div>
    </section>
  );
};

export default RecommendationPage;
